import { LandingCarousel } from '../../../../../store';

export const defaultCarousel: LandingCarousel = {
  id: Math.floor(Math.random() * 9999999),
  image: 'Enter image file',
  link: 'Enter path',
  headerText: 'Enter header',
  subHeaderText: 'Enter subheader',
  buttonText: 'Enter button text',
  isHidden: false,
  orderNum: 0
};
